/** @format */

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  ButtonGroup,
  CircularProgress,
  Hidden
} from '@mui/material';
import { FormikProps } from 'formik';
import React from 'react';
import SimpleBackdrop from '../loaders/backdrop';

interface Props {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  activeStep: number;
  formik: FormikProps<any>;
  status: string;
  isDisabled: boolean;
  setSaveAndClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function StepperButtons({
  setActiveStep,
  activeStep,
  formik,
  status,
  isDisabled,
  setSaveAndClose,
}: Props) {
  const handleSubmit = (isSaveAndCloseFlag: boolean) => {
    // Set intent before submit so Formik's onSubmit (runs after async validation)
    // sees the updated state on the next render and can show the save-and-close modal.
    if (isSaveAndCloseFlag) {
      setSaveAndClose(true);
    } else {
      setSaveAndClose(false);
    }
    formik.submitForm();
  };
  return (
    <>
      <SimpleBackdrop status={status} />
      <Hidden mdUp>
        <ButtonGroup fullWidth>
          <Button
            sx={{ fontSize: 11.5 }}
            startIcon={<ArrowBackIosIcon />}
            onClick={() => setActiveStep(activeStep - 1)}
            disabled={activeStep === 0}>
            Previous
          </Button>
          <Button
            startIcon={
              status === 'loading' ? (
                <CircularProgress
                  style={{ width: 15, height: 15, color: '#fff' }}
                />
              ) : (
                <SaveIcon />
              )
            }
            sx={{ fontSize: 11.5 }}
            onClick={() => handleSubmit(false)}
            // disabled={formik.isSubmitting || formik.isValidating || isDisabled}
            variant='contained'>
            {activeStep === 5 ? 'Submit Application' : 'Save & Continue'}
          </Button>
        </ButtonGroup>

        <LoadingButton
          fullWidth
          sx={{
            float: 'right',
            marginBottom: 1.5,
            marginTop: 2,
            fontSize: 11.5,
          }}
          color='info'
          variant='outlined'
          size='medium'
          disabled={activeStep === 5 || activeStep === 0}
          startIcon={<CloseIcon />}
          onClick={() => {
            handleSubmit(true);
          }}
          loadingPosition='start'>
          Save & Close
        </LoadingButton>
      </Hidden>

      <Hidden mdDown>
        <ButtonGroup>
          <Button
            startIcon={<ArrowBackIosIcon />}
            onClick={() => setActiveStep(activeStep - 1)}
            disabled={activeStep === 0}>
            Previous
          </Button>
          <Button
            startIcon={
              status === 'loading' ? (
                <CircularProgress
                  style={{ width: 15, height: 15, color: '#fff' }}
                />
              ) : (
                <SaveIcon />
              )
            }
            onClick={() => handleSubmit(false)}
            // disabled={formik.isSubmitting || formik.isValidating || isDisabled}
            variant='contained'>
            {activeStep === 5 ? 'Submit Application' : 'Save & Continue'}
          </Button>
        </ButtonGroup>

        <LoadingButton
          sx={{ float: 'right', marginBottom: 1.5 }}
          color='info'
          variant='outlined'
          size='medium'
          disabled={activeStep === 5 || activeStep === 0}
          startIcon={<CloseIcon />}
          onClick={() => {
            handleSubmit(true);
          }}
          loading={status === 'loading'}
          loadingPosition='start'>
          Save & Close
        </LoadingButton>
      </Hidden>
    </>
  );
}
